export default {
  'chevron-left': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M17.956 2.456L16.54 1.04 6.29 11.29a1.001 1.001 0 0 0 0 1.416l10.25 10.25 1.416-1.416-9.541-9.541 9.541-9.544z"/>`
  }
}
